import React, {useEffect} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import InputSearch from '../Input/InputSearch';

import styles from './Search.module.scss';

interface ISearchProps {
    // eslint-disable-next-line no-unused-vars
    onSubmit: (search: string) => void,
    disabled?: boolean,
    defaultValue?: string,
}

interface ISearchForm {
    search: string
}

const Search: React.FC<ISearchProps> = ({onSubmit: searchHandler, disabled, defaultValue}) => {
    const { register, control, handleSubmit, setValue, getValues } = useForm<ISearchForm>({
        mode: 'onChange',
        defaultValues: {search: defaultValue ?? ''},
    });

    useEffect(() => {
        setValue('search', defaultValue ?? '');
    }, [defaultValue, setValue]);

    const onSubmit: SubmitHandler<ISearchForm> = async({search}) => {
        searchHandler(search);
    };

    const handleClearSearch = () => {
        setValue('search', '');
        searchHandler('');
    };

    const handleSearchClick = () => {
        const searchValue = getValues('search') || '';
        searchHandler(searchValue);
    };

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            className={styles.wrapper}
        >
            <InputSearch
                type="text"
                name="search"
                register={register}
                control={control}
                className={cn(styles.search, disabled && styles.disabled)}
                placeholder={t`Поиск`}
                iconStyle={styles.icon}
                iconStyleClose={styles.iconClose}
                isMonitor
                disabled={disabled}
                onClear={handleClearSearch}
                onSearch={handleSearchClick}
            />
        </form>
    );
};

export default Search;